<template>
    <div class="viewpoints-wrap-temp">
        <Title v-if="page">
            <h2>What we do</h2>
        </Title>

        <div class="page-inner">
            <Content v-if="page">
                <h3 v-if="page.opening_paragraph">
                    {{ page.opening_paragraph }}
                </h3>

                <Accordion
                    v-if="page && page.accordions"
                    :content="page.accordions"
                    class="accordion-margin"
                />
                <RelatedLinks
                    v-if="page && page.clients && page.clients.length !== 0"
                    :title="page.list_title"
                    :list="page.clients"
                    page="services"
                />
                <ImageGrid v-if="page && page.images" :images="page.images" />
                <!-- <PostNewsletter :is_contact="true" v-if="page" /> -->
            </Content>
            <RelatedItems
                v-if="
                    page &&
                        page.related_items &&
                        page.related_items.length !== 0
                "
                :topSpacing="false"
                :list="page.related_items"
            />
            <Loading v-else class="static" />
        </div>
    </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import Content from "@/components/ui/Content.vue";
import ImageGrid from "@/components/ImageGrid.vue";

import Loading from "@/components/Loading.vue";
import RelatedItems from "@/components/RelatedItems.vue";
import RelatedLinks from "@/components/RelatedLinks.vue";
import PostNewsletter from "@/components/PostNewsletter.vue";
import Accordion from "@/components/Accordion.vue";

export default {
    name: "services",

    data() {
        return {
            page: false
        };
    },

    components: {
        Title,
        Content,
        Loading,
        RelatedItems,
        PostNewsletter,
        RelatedLinks,
        Accordion,
        ImageGrid
    },

    watch: {
        "$route.params": {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true
        }
    },

    methods: {
        fetchData(params) {
            this.page = false;
            // this.current_page_id = false;

            this.$ajax.get("pages?slug=services").then(res => {
                this.page = res.data[0];
                document.title =
                    window.globals.site_title +
                    " — " +
                    this.$decode(res.data[0].title.rendered);

                this.$store.state.is_loading = false;
            });
        }
    }
};
</script>

<style lang="scss">

@media(min-width: 1200px) {
    .viewpoints-wrap-temp {
        .ui-enter:not(.content-text) {
            padding: var(--padding);
        }
    }
}

@media (max-width: 1200px) {
    .page-inner {
        padding: 0 var(--margin);
    }
}

@media only screen and (max-width: 767px) {
    .accordion-margin {
        margin-bottom: 45px;
    }
}
</style>
